import { CheckIcon } from "@heroicons/react/outline";
import { Link, animateScroll as scroll } from "react-scroll";
import { lowerCase } from "lodash";

const features = [
    "Op maat gemaakt voeding,- en trainingsschema’s",
    "Geen dieet maar ‘normaal’ eten",
    "Een programma passend gemaakt in jouw leven",
    "Een lange termijn plan om een terugval uit te sluiten",
    "Dagelijks contact met onze Personal Trainers",
    "Personal training gericht op meer dan alleen ‘pompen’",
    "Geen belemmeringen zoals bodybuilders en drukte",
];

export default ({ location }) => {
    return (
        <div className="bg-black overflow-hidden">
            <div className="relative max-w-7xl mx-auto xs:py-4 sm:py-4 md:py-8 lg:py-16 px-4 sm:px-6 lg:px-8">
                <div className="hidden lg:block bg-black absolute top-0 bottom-0 left-3/4 w-screen" />
                <div className="mx-auto lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-none">
                    <h2 className="xs:text-center sm:text-center mt-2 text-5xl text-white font-custom italic font-bold uppercase">
                        Personal training {location} zet een nieuwe standaard
                        neer{" "}
                    </h2>
                </div>
                <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
                    <div className="relative lg:row-start-1 lg:col-start-2 xs:mb-16 sm:mb-16">
                        <div className="relative text-base mx-auto max-w-prose lg:max-w-none">
                            <div className="aspect-w-12 aspect-h-7 lg:aspect-none">
                                <picture>
                                    <source
                                        srcSet={`/assets/webp/personal-training-locatie-${lowerCase(
                                            location
                                        )}.webp`}
                                        width={1440}
                                        height={960}
                                        type="image/webp"
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                    <source
                                        srcSet={`/assets/personal-training-locatie-${lowerCase(
                                            location
                                        )}.jpg`}
                                        width={1440}
                                        height={960}
                                        type="image/jpeg"
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                    <img
                                        src={`/assets/personal-training-${lowerCase(
                                            location
                                        )}.jpg`}
                                        width={1440}
                                        height={960}
                                        alt="Boek succesvol afvallen zonder voedingsschema"
                                        className="rounded-lg shadow-lg object-cover object-center"
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 lg:mt-0">
                        <div className="text-base max-w-prose mx-auto lg:max-w-none">
                            <p className="text-lg text-gray-100">
                                WE – ARE your physical and mental personal
                                training {location} is de nieuwe standaard in{" "}
                                {location}. Het unieke Personal Training
                                programma is een vernieuwend concept. Met ons
                                twaalf weken programma helpen we de inwoners van
                                {location} en omstreken om de transformatie van
                                hun leven te maken zonder een jojo-effect als
                                gevolg! De filosofie is dat je het lichaam kunt
                                realiseren waar je mentaal kunt komen. Aan de
                                hand van Personal Training worden onze leden
                                eerste twaalf weken intensief begeleidt door hun
                                Personal Trainer. Na deze intensieve Personal
                                Training is er een mogelijkheid om door te
                                stromen naar onze private gym. Dit is een stukje
                                privé sportschool in {location} waar je de
                                behaalde resultaten kunt onderhouden of zelfs
                                verbeteren met deskundige begeleiding van onze
                                personal trainers. Met meer dan 1000+
                                transformaties kunnen we onszelf de specialisten
                                noemen van {location} en omstreken.
                            </p>
                            <div className="mt-5">
                                <ul className="">
                                    {features.map((feature, key) => (
                                        <li key={key} className="ml-0 pl-0">
                                            <CheckIcon
                                                className="absolute h-6 w-6 text-green-500"
                                                aria-hidden="true"
                                            />
                                            <p className="ml-9 text-lg text-gray-100">
                                                {feature}
                                            </p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="xs:text-center sm:text-center">
                                <Link
                                    to="contact"
                                    smooth={true}
                                    offset={0}
                                    duration={500}
                                    className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                                >
                                    Ik wil dit ook!
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
